import { render, staticRenderFns } from "./hx-home-content.vue?vue&type=template&id=afb0f5dc&"
import script from "./hx-home-content.vue?vue&type=script&lang=js&"
export * from "./hx-home-content.vue?vue&type=script&lang=js&"
import style0 from "./hx-home-content.vue?vue&type=style&index=0&id=afb0f5dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports